import allImgPaths from 'assets/images'
import CustomCheckBox from 'components/CustomCheckBox'
import { InputTextField } from 'components/InputField'
import Otp from 'components/Otp'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { sendOtp } from 'services/vendor'
import { signupValidationText } from 'utils/constant'
import { emailValidation } from 'utils/function'

const VendorLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState<any>(localStorage.getItem('vendorEmail') ? localStorage.getItem('vendorEmail') : '');
    const [errors, setErrors] = useState<any>({});

    const handleChange = (e: any) => {
        const value = e.target.value;

        const isValid = emailValidation(value);

        if (!isValid) {
            setErrors({ ...errors, email: signupValidationText.emailText });
        } else {
            setErrors({ ...errors, email: "" });
        }

        setEmail(value)
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault()

        try {
            const { data } = await sendOtp({ email })
            if (data) {
                localStorage.setItem("vendorEmail", email);
                setEmail("")
                navigate("/vendor/otp");
            }
        } catch (error) {
            console.log({ sendOtpError: error })
        }
    }

    return (
        <div className="flex">
            {/* Left banner */}
            <div className="w-1/2">
                <div className="bg-[#1E0AF5] flex flex-col justify-center items-center h-screen">
                    <img className='-mr-10' src={allImgPaths.vendorLoginBanner} alt="" />
                </div>
            </div>

            {/* Right banner */}
            <div className="w-1/2 flex flex-col">
                <div className="w-full h-screen flex items-center overflow-y-auto">
                    <div className="w-full max-w-[360px] mx-auto">
                        {/* Logo */}
                        <div className="text-center pb-6">
                            <img className="inline-block w-[220px]" src={allImgPaths.mainLogo} alt="logo" />
                        </div>

                        {/* Heading */}
                        <h1 className="font-interSemiBold text-[30px] text-[#101828] pb-8 text-center">Create an account</h1>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <InputTextField
                                    label={""}
                                    name={"email"}
                                    placeholder={"Enter Your Email"}
                                    onChange={handleChange}
                                    value={email}
                                    type="text"
                                    err={errors?.email}
                                />
                            </div>

                            <button
                                type="submit"
                                className={`submit-btn-blue w-full blue-btn-hover ${(!email || errors?.email) ? 'button-disabled' : ''}`}
                            >
                                Get started
                            </button>
                        </form>

                        <div className="flex items-center gap-x-3 my-6">
                            <span className='block h-px w-full bg-[#EAECF0]'></span>
                            <span className='text-sm font-interMedium text-[#475467]'>OR</span>
                            <span className='block h-px w-full bg-[#EAECF0]'></span>
                        </div>

                        <button
                            className="flex items-center gap-x-2 rounded-[10px] border border-[#D0D5DD] hover:border-[#1E0AF5] py-2.5 px-3.5 w-full justify-center mb-3"
                        >
                            <img src={allImgPaths.googleIcon} alt="google icon" />
                            <span className="font-interMedium">Sign up with Google</span>
                        </button>

                        <button
                            className="flex items-center gap-x-2 rounded-[10px] border border-[#D0D5DD] hover:border-[#1E0AF5] py-2.5 px-3.5 w-full justify-center"
                        >
                            <img className='w-6 h-6' src={allImgPaths.facebookIcon} alt="google icon" />
                            <span className="font-interMedium">Sign up with Facebook</span>
                        </button>

                        {/* Already Account */}
                        <div className="pt-8 text-center pb-6">
                            <span className='text-[#475467] text-sm'>Already have an account? </span>
                            <Link
                                className={`text-sm font-interSemiBold text-[#4B3BF7] hover:text-[#0C0462]`}
                                to="/login"
                            >
                                Log in
                            </Link>
                        </div>

                        <div className="text-center pb-2 flex items-center justify-center gap-x-2 text-[#545454]">
                            <Link
                                className="text-sm text-[#545454] hover:text-[#1e0af5]"
                                to="/login"
                            >
                                Terms of use
                            </Link>
                            |
                            <Link
                                className="text-sm text-[#545454] hover:text-[#1e0af5]"
                                to="/login"
                            >
                                Privacy policy
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VendorLogin